<div *ngIf="isWizardActive" class="wizard">
    <sh-popover class="wizard-popover" passive sticky visible position={{wizardData.position}}
    target={{wizardData.id}} [visible]='isWizardActive'>
    <span class="wizard-span">
      <sh-icon icon="cancel" size="xs" button slot="functions" (click)='closePermanently = false' onclick="document.querySelector('#closeWizardModal').visible = true; document.querySelector('#dontShowMessageCheck').active=false;"></sh-icon>
    </span>
      {{wizardData.description}}
      <sh-text href='#' class="wizard-text" size='body-1' color="primary" slot='footer' (click)="nextWizard($event)" >{{wizardLinkValue}}</sh-text>
    </sh-popover>

    <sh-modal id="closeWizardModal" class="wizard-modal" type='alert' label='Information' modal-height='184px' modal-width='450px'>
      <sh-text class="wizard-modal-text" size='title-1' size="title-1" color="primary">This will close VAL user guide. Do you want to continue?</sh-text>

      <sh-checkbox class="wizard-checkbox" id='dontShowMessageCheck' label='Dont show this again' (click)="closePermanentlyOptionOpted($event)" slot="footer"></sh-checkbox>
      <sh-button slot="footer" color="secondary" label="Cancel" onclick="document.querySelector('#closeWizardModal').visible = false"></sh-button>
      <sh-button slot="footer" label="Ok" (click)='closeWizard($event)' onclick="document.querySelector('#closeWizardModal').visible = false"></sh-button>
    </sh-modal>
  </div>
